import React from 'react';
import { Button } from './Button';
import { NetworkErrorIcon } from '../icons';

type NetworkErrorWidgetProps = {
    onRetry: () => void;
};

export const NetworkErrorWidget: React.FC<NetworkErrorWidgetProps> = ({ onRetry }) => (
    <div style={{ textAlign: 'center', width: '100%' }}>
        <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}>
            <NetworkErrorIcon />
        </div>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '0 0 8px 0', color: '#111827' }}>
            Connection failed
        </h2>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 28px 0' }}>
            Check your internet connection and try again.
        </p>
        <Button onClick={onRetry}>Retry</Button>
    </div>
);
